import { render, staticRenderFns } from "./BuyVip.vue?vue&type=template&id=18e12d22&scoped=true&"
import script from "./BuyVip.vue?vue&type=script&lang=js&"
export * from "./BuyVip.vue?vue&type=script&lang=js&"
import style0 from "./BuyVip.vue?vue&type=style&index=0&id=18e12d22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e12d22",
  null
  
)

export default component.exports